import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const InquirySection = () => {
  const { t } = useLanguage();

  return (
    <section id="inquire" className="section-spacing bg-warm-black">
      <div className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-28">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="font-label text-bronze block mb-8">
              Contact
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-primary-foreground leading-[1.05] mb-10">
              {t("Begin a", "Start een")}<br />{t("conversation.", "gesprek.")}
            </h2>
            <p className="font-body text-primary-foreground/50 text-sm md:text-base max-w-md leading-[1.9] mb-12">
              {t(
                "Have a different request? Our team is happy to assist with any bespoke arrangements.",
                "Heeft u een ander verzoek? Ons team helpt u graag met elke op maat gemaakte regeling."
              )}
            </p>

            <div className="space-y-5">
              <a
                href="tel:+31619038233"
                className="font-label text-primary-foreground/60 hover:text-primary-foreground transition-colors duration-700 block"
              >
                +31 6 19038233
              </a>
              <a
                href="https://wa.me/message/2XEKJ5STR2IZJ1"
                target="_blank"
                rel="noopener noreferrer"
                className="font-label text-primary-foreground/60 hover:text-primary-foreground transition-colors duration-700 block"
              >
                WhatsApp →
              </a>
              <a
                href="mailto:info@arzanigroupworldwide.com"
                className="font-label text-primary-foreground/60 hover:text-primary-foreground transition-colors duration-700 block"
              >
                info@arzanigroupworldwide.com →
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="flex h-full min-h-[320px] flex-col justify-center border-y border-primary-foreground/10 py-12">
              <span className="font-label text-bronze">{t("Private concierge", "Private concierge")}</span>
              <h3 className="mt-5 max-w-lg font-display text-3xl leading-tight text-primary-foreground md:text-4xl">
                {t("A considered request begins with a few simple details.", "Een bijzondere aanvraag begint met enkele eenvoudige details.")}
              </h3>
              <p className="mt-6 max-w-md font-body text-sm leading-7 text-primary-foreground/50">
                {t("Choose your service, share your preferences and leave every arrangement to us.", "Kies uw service, deel uw voorkeuren en laat iedere regeling aan ons over.")}
              </p>
              <Button asChild className="mt-9 h-12 w-fit rounded-sm bg-primary-foreground px-6 font-label text-warm-black hover:bg-primary-foreground/90">
                <Link to="/contact">{t("Request Concierge Assistance", "Vraag Concierge Assistentie")}<ArrowUpRight className="h-4 w-4" /></Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default InquirySection;
